import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Checkbox from '../Checkbox/Checkbox'
import MoreVert from '../icons/MoreVert'
import Menu from '../Menu/Menu'
import Progress from '../Progress/Progress'
import { ActionTypes } from './Actions'
import Cell from './Cell'
import type { TableColumn } from './Table'
import { useTable } from './Table'

function Body(): JSX.Element {
  const intl = useIntl()
  const [state, dispatch] = useTable()

  if (state.selectable) {
    const column = state.columns.selected.find(
      (column) => column.key !== 'checkbox',
    ) as TableColumn

    state.rows = state.rows.map((row) => {
      const handleChange = () => {
        dispatch({
          type: ActionTypes.ToggleRow,
          key: row.id,
          selectionsRef: state.selectionsRef,
        })
      }

      return {
        ...row,
        checkbox: (
          <Checkbox.Input
            aria-label={intl.formatMessage(
              { id: 'Table.select_row' },
              { row: `${row[column.key]}` },
            )}
            defaultChecked={row.selected}
            onChange={handleChange}
            tabIndex={-1}
          />
        ),
      }
    })
  }

  return (
    <tbody>
      {state.loading ? (
        <tr className="absolute inset-0 flex items-center justify-center mt-32">
          <td>
            <Progress variant="circular">
              <Progress.Description>
                <FormattedMessage id="Ui.loading" />
              </Progress.Description>
            </Progress>
          </td>
        </tr>
      ) : (
        state.rows.slice(0, Number(state.limit)).map((row) => {
          return (
            <tr
              aria-selected={
                state.selectable
                  ? row?.selected
                    ? 'true'
                    : 'false'
                  : undefined
              }
              className="border-b border-black-10 last:border-b-0 group"
              key={row.id}
            >
              {state.columns.selected.map((column) => (
                <Cell key={column.key} selected={row?.selected}>
                  {row[column.key] ? (
                    row[column.key]
                  ) : (
                    <span className="text-black-45">
                      <FormattedMessage id="Table.not_specified" />
                    </span>
                  )}
                </Cell>
              ))}
              <Cell selected={row?.selected} sticky>
                {state.rowActions?.length ? (
                  <Menu placement="bottom-end">
                    <Menu.Button
                      icon
                      label={intl.formatMessage({ id: 'Table.more_actions' })}
                    >
                      <MoreVert />
                    </Menu.Button>
                    <Menu.Items>
                      {state.rowActions
                        ?.filter((action) => {
                          if (action.enabled) {
                            return action.enabled(row)
                          }

                          return true
                        })
                        ?.map((action) => {
                          const onClick = () => {
                            action.handler(row)
                          }

                          return (
                            <div
                              className="text-black-60"
                              key={`${row.id}-${action.label}`}
                            >
                              <Menu.Item
                                onClick={onClick}
                                startAdornment={action.startAdornment}
                              >
                                <div className="text-black-90">
                                  {action.label}
                                </div>
                              </Menu.Item>
                            </div>
                          )
                        })}
                    </Menu.Items>
                  </Menu>
                ) : null}
              </Cell>
            </tr>
          )
        })
      )}
    </tbody>
  )
}

export default Body
